import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/gastos',
    name: 'gastos.index',
    component: () => import('./views/GastosIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'gastos.read',
      breadcrumb: 'Gastos',
    },
  },
]

export default routes
